import React, { useState, useEffect } from "react";
import axios from "axios";
import { GoogleMap, useJsApiLoader, Marker, OverlayView } from "@react-google-maps/api";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";

const containerStyle = {
    width: "98%",
    height: "80vh",
};

const center = {
    lat: 28.5116,  // Default latitude
    lng: 77.2878,  // Default longitude
};

const GoogleMapComponent_v2 = ({ lat_long = "28.5116 77.2878" }) => {

    const [lat, lng] = (typeof lat_long === "string" ? lat_long : "28.5116 77.2878")
    .split(" ")
    .map(Number);
if(lat != 0){
    const center = { lat, lng };
}

    const [equipments, setEquipments] = useState([]);
    const [loading, setLoading] = useState(false);

    // ✅ Use `useJsApiLoader` to ensure Google Maps API is loaded
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDPMF7fzNp0C0PJbwtSFQNf1icTv2ceO4c",
    });

    useEffect(() => {
        GetData();
    }, []);

    const GetData = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://ctas.live/backend/api/get/equipments");
            setEquipments(response.data.data); // Assuming response.data.data contains an array of equipment
        } catch (error) {
            console.error("Error fetching equipment data:", error);
        } finally {
            setLoading(false);
        }
    };

    const CustomMarker = ({ position, number }) => {
        return (
            <OverlayView
                position={position}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
                <div
                    style={{
                        position: "relative",
                        width: "50px",
                        height: "50px",
                        backgroundImage: "url(/rst.png)",
                        backgroundSize: "cover",
                        textAlign: "center",
                        lineHeight: "50px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "white",
                        borderRadius: "5%",
                        border: "2px solid blue",
                    }}
                >
                    {number}
                </div>
            </OverlayView>
        );
    };


    const CustomMarker_2 = ({ position, number }) => {
                return (
                    <OverlayView
                        position={position}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                        <div
                            style={{
                                position: "relative",
                                width: "30px",
                                height: "40px",
                                backgroundImage: "url(/pointer.png)",
                                backgroundSize: "cover",
                                textAlign: "center",
                                lineHeight: "50px",
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "white",
                                // borderRadius: "5%",
                                // border: "2px solid blue",
                            }}
                        >
                            {number}
                        </div>
                    </OverlayView>
                );
            };

    // ✅ Prevent rendering until Google Maps is fully loaded
    if (!isLoaded) return <p>Loading map...</p>;

    return (
        <>

        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17.5} mapTypeId="satellite">
            {/* Default Marker */}
            {/* <Marker
                position={center}
                icon={{
                    url: "/rst.png",
                    scaledSize: new window.google.maps.Size(50, 50),
                }}
            /> */}

            {/* Dynamic Markers */}
            {equipments.map((equipment, index) => (
                <CustomMarker position={{ lat: parseFloat(equipment.latitude), lng: parseFloat(equipment.longitude) }} number={equipment.equipment_name} />
            ))}

            <CustomMarker_2 position={{ lat: parseFloat(lat), lng: parseFloat(lng) }} number={''} />

        </GoogleMap>
                            


        </>
    );
};

export default GoogleMapComponent_v2;
